import { z } from 'zod';

/**
 * Statut d'une personne dans son réseau — ce n'est pas une information RH,
 * c'est la **chaîne de responsabilité** (docs/specs/typologie-partenaire.md §2).
 *
 * - `employee` : salarié du réseau, sous la responsabilité directe de son
 *   manager. Un compte sans adresse email lui est ouvert.
 * - `contractor` : non salarié (intérimaire, sous-traitant, indépendant). Il
 *   n'est pas sous la responsabilité directe du manager : une adresse email
 *   professionnelle est **imposée**, c'est la seule façon d'être joignable et
 *   de récupérer son accès sans passer par la hiérarchie.
 *
 * Un alternant est un salarié (précisé en réunion).
 */
export const EmploymentStatusSchema = z.enum(['employee', 'contractor']);
export type EmploymentStatus = z.infer<typeof EmploymentStatusSchema>;

export const EMPLOYMENT_STATUS_LABEL_FR: Record<EmploymentStatus, string> = {
  employee: 'Salarié',
  contractor: 'Non salarié',
};

export const EMPLOYMENT_STATUS_DESCRIPTION_FR: Record<EmploymentStatus, string> = {
  employee: 'Sous la responsabilité de son manager. Un alternant est un salarié.',
  contractor: 'Intérimaire, sous-traitant, indépendant : adresse email obligatoire.',
};
